// extracted by mini-css-extract-plugin
export default {"viewToggleGroup":"ViewToggle_viewToggleGroup__aZ+xU","viewToggleBtn":"ViewToggle_viewToggleBtn__lKXx5","viewToggleBtnActive":"ViewToggle_viewToggleBtnActive__AEtXe"};